

<template>
    <div class="boxHeader1">
        <div class="boxHeader1Item" @click="toIndex()">首页</div>
        <div class="boxHeader1Item" v-for="cls in classList" @click="toGameList(cls.id)" >
          {{cls.name}}
        </div>

    </div>
</template>
<script>
  import {getGameClassList} from "@/api/qt/common";

  export default {
    props:['selectOption'],
    data(){
      return {
        classList:[],
        nowSelectId:0,
      }
    },
    created() {
      this.getClassList();
    },
    mounted() {

    },
    methods:{
      toIndex(){
        this.$router.push('/');
      },
      toGameList(cid){
        this.nowSelectId=cid;
        if(this.$route.name=='index' || this.$route.name=='detail'){

          localStorage.setItem('cid',cid)
          setTimeout(()=>{
            localStorage.removeItem('cid')
          },1000)
          this.$router.push({path:'/gameList',query:{cid:cid},params:{cid:cid}});
        }else{

          this.$emit("selectOption",2,cid)
        }
      },
      getClassList(){
        getGameClassList().then((res)=>{
          this.classList = res.data.data;
          this.classList=this.classList[0].with_option



        })
      }
    }
  }
</script>
<style scoped>
  .boxHeader1{
    width: 100%;
    background-color: #2c3e50;
    display: flex;
    border-radius: 4px;
    align-items: center;
  }
  .boxHeader1Item{
    margin-right: 20px;
    color: #fff;
    height: 36px;
    border-bottom: 1px solid #2c3e50;
    box-sizing: border-box;
    cursor: pointer;
    margin-top: 2px;
    margin-bottom: 2px;

  }
</style>
